import PropTypes from "prop-types";

import { strCode } from "../../../../../consts";
import { t } from "../../../../../services";

import FlexContainers from "../../../../Containers/FlexContainers";
import Notification from "../../../../Notification/Notification";

import ImportedRecordsTable from "../../ImportedRecordsTable/ImportedRecordsTable";
import { ImportingSummaryWrapper, TableTitle } from "./styled";
import WrapperContainer from "../../../../Containers/WrapperContainer";

const CorrectRecordsSummary = ({
  correctRecords,
  totalLength,
  successInfo,
  ImportedRecordsTableColumns,
  SuccessImportActions
}) => {
  return (
    <ImportingSummaryWrapper Container={FlexContainers.FlexColumnStart} width={"100%"} gap={24}>
      <Notification
        id="users-import-success"
        type="success"
        title={
          correctRecords.length === totalLength
            ? t(strCode.SUCCESSFUL_IMPORT_TITLE)
            : t(strCode.PARTIALY_SUCCESSFUL_IMPORT_TITLE)
        }
        message={t(successInfo, {
          correctRecords: correctRecords?.length,
          totalLength
        })}
      />

      <WrapperContainer Container={FlexContainers.FlexRowBetween} width={"100%"}>
        <TableTitle>{`${t(strCode.CORRECT_RECORDS)} (${correctRecords.length})`}</TableTitle>
        {SuccessImportActions ? <SuccessImportActions records={correctRecords} /> : null}
      </WrapperContainer>

      <ImportedRecordsTable
        records={correctRecords}
        ImportedRecordsTableColumns={ImportedRecordsTableColumns}
      />
    </ImportingSummaryWrapper>
  );
};

CorrectRecordsSummary.propTypes = {
  correctRecords: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number.isRequired,
      correct: PropTypes.bool.isRequired
    }).isRequired
  ),
  totalLength: PropTypes.number.isRequired,
  successInfo: PropTypes.string.isRequired,
  ImportedRecordsTableColumns: PropTypes.oneOfType([PropTypes.node, PropTypes.object]).isRequired,
  SuccessImportActions: PropTypes.oneOfType([PropTypes.node, PropTypes.object])
};

export default CorrectRecordsSummary;
